import { useEffect, useState, useRef } from 'react';
import { io } from 'socket.io-client';
import Cookies from "js-cookie";
import { api } from "../config";

import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

const defaultOptions = {
  transports: ['websocket'],
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 2000,
};


export const useSocket = (uri = api.SOCKET_URL  ) => {
//   const dispatch = useDispatch();
//   const { t } = useTranslation();
  const socketRef = useRef(null);
  const [isConnected, setIsConnected] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);

  const finalOpts = { 
    ...defaultOptions,
    auth: { token: Cookies.get("authorization") },
  };

  // ---- lifecycle ----
  useEffect(() => {
    const newSocket = io(uri, finalOpts);
    socketRef.current = newSocket;

    if (newSocket.connected) setIsConnected(true);

    const onConnect = () => { 
      newSocket.emit('pong_check');
      console.log('Connected succesfully!') 
    }
    const onDisconnect = (reason) => {
      setIsConnected(false)
      console.log('Disconnected succesfully! - ', reason)
    };
    const onConnectError = (error) => console.error('Socket connection error:', error);

    const onCountryEvent = (data) => {
      const response = JSON.parse(data);
      if (response.StatusCode === 200) {
        setIsConnected(true);
        // const countryId = response?.Data[0]?.ID;
        // localStorage.setItem('CountryID', countryId);

        // const payload = {
        //   RoleID: '',
        //   Platform: 'Web',
        //   AppVersion: '1.0',
        // };
        // newSocket.emit('AppConfiguration', JSON.stringify(payload));
      } else if (response.StatusCode === 403) {
        // dispatch(setErrorMessage({
        //   message: t('CommonScreen.AppRistrictMessage'),
        //   close: false
        // }))
      } else if (response.StatusCode === 503) {
        // dispatch(setErrorMessage({
        //   message: t('CommonScreen.AppUnderMaintenanceMsg'), 
        //   close: false
        // }))
      }
    }

    const onAppConfigurationEvent = (data) => {
      const response = JSON.parse(data);
      if (response?.Data?.Environment) {
        localStorage.setItem('Environment', response?.Data?.Environment);
      }
      setIsInitialized(true);
    }

    const onNetworkEvent = () => {
      newSocket.emit('pong_check')
    }

    newSocket.on('connect', onConnect);
    newSocket.on('disconnect', onDisconnect);
    newSocket.on('connect_error', onConnectError);
    newSocket.on('CountryEvent', onCountryEvent);
    newSocket.on('ping_check', onNetworkEvent);
    // newSocket.on('AppConfiguration', onAppConfigurationEvent);

    return () => {
      newSocket.off('connect', onConnect);
      newSocket.off('disconnect', onDisconnect);
      newSocket.off('connect_error', onConnectError);
      newSocket.on('ping_check', onNetworkEvent);
    //   newSocket.off('CountryEvent', onCountryEvent);
    //   newSocket.off('AppConfiguration', onAppConfigurationEvent);
      newSocket.disconnect();
      socketRef.current = null;
      setIsInitialized(false);
    };
  }, [uri]);

  return { socket: socketRef.current, isConnected, isInitialized };
};
